<div class="row mb-1">
	<div class="col-lg-10">
		<input type="text" class="form-control " name="new_email" placeholder="Email Address" #el
			   [(ngModel)]="data.newEmail"
			   (ngModelChange)="data.error = false;data.errorDuplicate = false">
		<div class="alert alert-danger" *ngIf="data.error">Please enter a valid email address</div>
		<div class="alert alert-danger" *ngIf="data.errorDuplicate">You have already added this email
			address
		</div>
	</div>
	<div class="col-lg-2">
		<button mat-button [hidden]="data.validating"
				class="input-group-text  {{kindaValidEmail(data.newEmail)?'btn-primary bg-blue-important white-important':'btn-disabled'}}"
				(click)="addToEmails()">Add
		</button>
		<ui-loading [loadingText]="'validating email'" [loading]="data.validating"></ui-loading>
	</div>


</div>
<div class="row" [hidden]="data.emails.length===0">
	<div class="col-lg-12">
		<select multiple [style.height.px]="21+length(data.emails)*21" class="form-control"
				[(ngModel)]="data.selected" name="rejection.data.emails[]" #multiSelectRejectionEmails
				id="multiSelectRejectionEmails">
			<option *ngFor="let em of data.emails">{{em}}</option>

		</select>
		<button
			class="btn {{length(data.selected)?'btn-danger':'btn-disabled'}} btn-sm helper-multi-select-remove-button"
			(click)="removeEmails(multiSelectRejectionEmails.options)">
			Remove selected
		</button>
	</div>
</div>
